import React from "react";
import {
  Award, Compass, ScanSearch, Clock, Palette, Smile,
} from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { useReveal } from "../../hooks/useReveal";

const ICONS = [Award, Compass, ScanSearch, Clock, Palette, Smile];

export const WhyChoose = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="why-choose"
      data-testid="why-choose-section"
      className="bg-bg-base py-16 md:py-20"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="overline">{t.whyChoose.overline}</p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-accent-dark mt-4 tracking-tight font-light leading-[1.1]">
            {t.whyChoose.title}
          </h2>
          <span className="hairline mt-7 mb-7 mx-auto block" />
          <p className="text-text-muted text-base md:text-lg leading-relaxed">
            {t.whyChoose.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border-soft border border-border-soft">
          {t.whyChoose.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <article
                key={i}
                data-testid={`why-choose-item-${i}`}
                className="bg-white p-8 md:p-10 transition-colors duration-500 hover:bg-bg-alt"
              >
                <div className="w-11 h-11 rounded-full bg-bg-alt flex items-center justify-center text-gold mb-6">
                  <Icon size={20} strokeWidth={1.4} />
                </div>
                <h3 className="font-serif text-xl md:text-2xl text-accent-dark font-light leading-tight">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-text-muted leading-relaxed">
                  {item.desc}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
